module.exports = __webpack_public_path__ + "img/24.e5e04083.jpg";